import { SpaceLabelsModel } from './model/space-labels-model.interface';
import { SpaceLabelsModelImpl } from './model/space-labels-model';
import { SpaceLabelsService } from './services/space-labels-service.interface';
import { SpaceLabelsServiceImpl } from './services/space-labels-service';
import { SpaceLabelsRepository } from './services/space-labels-repository.interface';
import { SpaceLabelsRepositoryImpl } from './repositories/space-labels-repository';
export function spaceLabelsModule(bind) {
    bind(SpaceLabelsModel).to(SpaceLabelsModelImpl);
    bind(SpaceLabelsService).to(SpaceLabelsServiceImpl);
    bind(SpaceLabelsRepository).to(SpaceLabelsRepositoryImpl);
}
